import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { codepoints } from "../text";
import { MAX_MESSAGE_LENGTH } from "../validate";
import InboxPreview from "../previews/InboxPreview";

// NOTIF-16 — the two type values the API accepts. Default (general.new.article)
// lives in Composer.js's initialState, not here.
export const TYPE_OPTIONS = ["general.new.update", "general.new.article"];

// NOTIF-16 — the five category values the API accepts.
export const CATEGORY_OPTIONS = ["general", "workspace", "mentions", "carbonVoice", "security"];

// NOTIF-15 AC8 — the six deep-link path shapes an operator can assemble by hand.
export const ACTION_URL_HELPER_TEXT =
  "Deep-link shapes: /c/{channel_id}, /m/{message_id}, /w/{workspace_id}, " +
  "/s/{share_link_id}, /a/todo?id={id}, /a/user/profile?user_id={id}";

export default function ContentStep({ state, dispatch, errors = {} }) {
  const setField = (field) => (event) =>
    dispatch({ type: "SET_FIELD", field, value: event.target.value });

  const messageLength = codepoints((state.message || "").trim());
  const overMessageLimit = messageLength > MAX_MESSAGE_LENGTH;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", flexWrap: "wrap" }}>
        <Box sx={{ flex: 1, minWidth: 240 }}>
          <TextField
            label="Message"
            value={state.message}
            onChange={setField("message")}
            error={Boolean(errors.message)}
            helperText={errors.message || " "}
            multiline
            minRows={3}
            fullWidth
          />
          <Typography variant="body2" color={overMessageLimit ? "error" : "text.secondary"}>
            {messageLength} / {MAX_MESSAGE_LENGTH}
          </Typography>
        </Box>

        {/* NOTIF-24 — updates per keystroke via state.message/state.category */}
        <InboxPreview message={state.message} category={state.category} />
      </Box>

      <Box>
        <TextField
          label="Link"
          value={state.action_url}
          onChange={setField("action_url")}
          error={Boolean(errors.action_url)}
          helperText={errors.action_url || " "}
          fullWidth
        />
        <Typography variant="caption" color="text.secondary">
          {ACTION_URL_HELPER_TEXT}
        </Typography>
      </Box>

      <TextField select label="Type" value={state.type} onChange={setField("type")} fullWidth>
        {TYPE_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label="Category"
        value={state.category}
        onChange={setField("category")}
        fullWidth
      >
        {CATEGORY_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
